import { BusHour } from "./BusTimes";

export const BUS_TIMES_SATURDAYS: BusHour[] = [
  {
    hour: 0,
    minute: 5,
  },
  {
    hour: 0,
    minute: 20,
  },
  {
    hour: 0,
    minute: 35,
  },
  {
    hour: 5,
    minute: 9,
  },
  {
    hour: 5,
    minute: 25,
  },
  {
    hour: 5,
    minute: 40,
  },
  {
    hour: 5,
    minute: 59,
  },
  {
    hour: 6,
    minute: 9,
  },
  {
    hour: 6,
    minute: 19,
  },
  {
    hour: 6,
    minute: 29,
  },
  {
    hour: 6,
    minute: 39,
  },
  {
    hour: 6,
    minute: 49,
  },
  {
    hour: 6,
    minute: 59,
  },
  {
    hour: 7,
    minute: 9,
  },
  {
    hour: 7,
    minute: 19,
  },
  {
    hour: 7,
    minute: 29,
  },
  {
    hour: 7,
    minute: 39,
  },
  {
    hour: 7,
    minute: 49,
  },
  {
    hour: 7,
    minute: 59,
  },
  {
    hour: 8,
    minute: 8,
  },
  {
    hour: 8,
    minute: 18,
  },
  {
    hour: 8,
    minute: 28,
  },
  {
    hour: 8,
    minute: 38,
  },
  {
    hour: 8,
    minute: 48,
  },
  {
    hour: 8,
    minute: 58,
  },
  {
    hour: 9,
    minute: 8,
  },
  {
    hour: 9,
    minute: 18,
  },
  {
    hour: 9,
    minute: 27,
  },
  {
    hour: 9,
    minute: 37,
  },
  {
    hour: 9,
    minute: 47,
  },
  {
    hour: 9,
    minute: 57,
  },
  {
    hour: 10,
    minute: 7,
  },
  {
    hour: 10,
    minute: 17,
  },
  {
    hour: 10,
    minute: 27,
  },
  {
    hour: 10,
    minute: 37,
  },
  {
    hour: 10,
    minute: 47,
  },
  {
    hour: 10,
    minute: 57,
  },
  {
    hour: 11,
    minute: 7,
  },
  {
    hour: 11,
    minute: 17,
  },
  {
    hour: 11,
    minute: 27,
  },
  {
    hour: 11,
    minute: 37,
  },
  {
    hour: 11,
    minute: 47,
  },
  {
    hour: 11,
    minute: 57,
  },
  {
    hour: 12,
    minute: 7,
  },
  {
    hour: 12,
    minute: 17,
  },
  {
    hour: 12,
    minute: 27,
  },
  {
    hour: 12,
    minute: 37,
  },
  {
    hour: 12,
    minute: 47,
  },
  {
    hour: 12,
    minute: 57,
  },
  {
    hour: 13,
    minute: 7,
  },
  {
    hour: 13,
    minute: 17,
  },
  {
    hour: 13,
    minute: 27,
  },
  {
    hour: 13,
    minute: 37,
  },
  {
    hour: 13,
    minute: 47,
  },
  {
    hour: 13,
    minute: 57,
  },
  {
    hour: 14,
    minute: 7,
  },
  {
    hour: 14,
    minute: 17,
  },
  {
    hour: 14,
    minute: 27,
  },
  {
    hour: 14,
    minute: 37,
  },
  {
    hour: 14,
    minute: 47,
  },
  {
    hour: 14,
    minute: 57,
  },
  {
    hour: 15,
    minute: 7,
  },
  {
    hour: 15,
    minute: 17,
  },
  {
    hour: 15,
    minute: 27,
  },
  {
    hour: 15,
    minute: 37,
  },
  {
    hour: 15,
    minute: 47,
  },
  {
    hour: 15,
    minute: 57,
  },
  {
    hour: 16,
    minute: 7,
  },
  {
    hour: 16,
    minute: 17,
  },
  {
    hour: 16,
    minute: 27,
  },
  {
    hour: 16,
    minute: 37,
  },
  {
    hour: 16,
    minute: 47,
  },
  {
    hour: 16,
    minute: 57,
  },
  {
    hour: 17,
    minute: 7,
  },
  {
    hour: 17,
    minute: 17,
  },
  {
    hour: 17,
    minute: 27,
  },
  {
    hour: 17,
    minute: 37,
  },
  {
    hour: 17,
    minute: 47,
  },
  {
    hour: 17,
    minute: 57,
  },
  {
    hour: 18,
    minute: 7,
  },
  {
    hour: 18,
    minute: 17,
  },
  {
    hour: 18,
    minute: 27,
  },
  {
    hour: 18,
    minute: 38,
  },
  {
    hour: 18,
    minute: 48,
  },
  {
    hour: 18,
    minute: 58,
  },
  {
    hour: 19,
    minute: 8,
  },
  {
    hour: 19,
    minute: 18,
  },
  {
    hour: 19,
    minute: 28,
  },
  {
    hour: 19,
    minute: 38,
  },
  {
    hour: 19,
    minute: 48,
  },
  {
    hour: 19,
    minute: 58,
  },
  {
    hour: 20,
    minute: 8,
  },
  {
    hour: 20,
    minute: 18,
  },
  {
    hour: 20,
    minute: 28,
  },
  {
    hour: 20,
    minute: 38,
  },
  {
    hour: 20,
    minute: 48,
  },
  {
    hour: 20,
    minute: 56,
  },
  {
    hour: 21,
    minute: 5,
  },
  {
    hour: 21,
    minute: 20,
  },
  {
    hour: 21,
    minute: 35,
  },
  {
    hour: 21,
    minute: 50,
  },
  {
    hour: 22,
    minute: 5,
  },
  {
    hour: 22,
    minute: 20,
  },
  {
    hour: 22,
    minute: 35,
  },
  {
    hour: 22,
    minute: 50,
  },
  {
    hour: 23,
    minute: 5,
  },
  {
    hour: 23,
    minute: 20,
  },
  {
    hour: 23,
    minute: 35,
  },
  {
    hour: 23,
    minute: 50,
  },
];
